import { useEffect, useState } from "react";
import api from "@/lib/api";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import { Briefcase, Phone, MapPin } from "lucide-react";

export default function JobsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/jobs").then((r) => setItems(r.data)).catch(() => {}).finally(() => setLoading(false)); }, []);

  return (
    <>
      <PublicHeader />
      <section className="bg-gradient-to-br from-emerald-800 to-teal-900 text-white">
        <div className="max-w-6xl mx-auto px-4 py-12">
          <div className="flex items-center gap-3 mb-2"><Briefcase className="w-5 h-5 text-amber-300"/>
            <span className="uppercase tracking-[0.28em] text-[11px] text-amber-300 font-black">Jobs Board · रोज़गार</span></div>
          <h1 className="font-devnagri-heading text-4xl md:text-5xl font-black">आज की <span className="text-amber-300">नौकरियाँ</span></h1>
          <p className="text-slate-200 mt-3">स्थानीय एवं क्षेत्रीय नौकरियों के अवसर</p>
        </div>
      </section>
      <main className="max-w-6xl mx-auto px-4 py-10" data-testid="jobs-page">
        {loading ? <div className="text-slate-500">लोड हो रहा है…</div> :
          items.length === 0 ? <div className="text-slate-500 italic py-12 text-center">फ़िलहाल कोई नौकरी उपलब्ध नहीं। जल्द ही नयी नौकरियाँ जोड़ी जाएँगी।</div> :
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {items.map((j) => (
              <div key={j.id} className="bg-white rounded-lg border border-slate-200 p-5 hover:shadow-md transition" data-testid={`job-${j.id}`}>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded bg-emerald-100 text-emerald-700 flex items-center justify-center shrink-0"><Briefcase className="w-5 h-5"/></div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-bold text-[#0F172A]">{j.title}</h3>
                    <p className="text-sm text-slate-600 mt-1 line-clamp-3">{j.description}</p>
                    <div className="flex items-center gap-3 text-xs text-slate-500 mt-2 flex-wrap">
                      <a href={`tel:${j.phone}`} className="flex items-center gap-1 hover:text-[#DC2626]"><Phone className="w-3 h-3"/>{j.phone}</a>
                      {j.area && <span className="flex items-center gap-1"><MapPin className="w-3 h-3"/>{j.area}</span>}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        }
      </main>
      <PublicFooter />
    </>
  );
}
